/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Tags1Inputs */

const id_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const ms_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const da_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const de_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const en_us2_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const es_es2_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const es_mx2_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const fil_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Tag`)
};

const fr_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const it_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const hu_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Címkék`)
};

const nl_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const no_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagger`)
};

const pl_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagi`)
};

const pt_br2_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const pt_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const ro_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichete`)
};

const fi_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagit`)
};

const sv_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taggar`)
};

const vi_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ`)
};

const tr_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiketler`)
};

const cs_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Štítky`)
};

const bg_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Етикети`)
};

const ru_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const uk_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const ar_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوسوم`)
};

const hi_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग`)
};

const th_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แท็ก`)
};

const ja_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const zh_cn2_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const zh_hant1_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標籤`)
};

const ko_offerdetail_table_tags1 = /** @type {(inputs: Offerdetail_Table_Tags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`태그`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Offerdetail_Table_Tags1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_tags1 = /** @type {((inputs?: Offerdetail_Table_Tags1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Tags1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_tags1(inputs)
	if (locale === "ms") return ms_offerdetail_table_tags1(inputs)
	if (locale === "da") return da_offerdetail_table_tags1(inputs)
	if (locale === "de") return de_offerdetail_table_tags1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_tags1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_tags1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_tags1(inputs)
	if (locale === "fil") return fil_offerdetail_table_tags1(inputs)
	if (locale === "fr") return fr_offerdetail_table_tags1(inputs)
	if (locale === "it") return it_offerdetail_table_tags1(inputs)
	if (locale === "hu") return hu_offerdetail_table_tags1(inputs)
	if (locale === "nl") return nl_offerdetail_table_tags1(inputs)
	if (locale === "no") return no_offerdetail_table_tags1(inputs)
	if (locale === "pl") return pl_offerdetail_table_tags1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_tags1(inputs)
	if (locale === "pt") return pt_offerdetail_table_tags1(inputs)
	if (locale === "ro") return ro_offerdetail_table_tags1(inputs)
	if (locale === "fi") return fi_offerdetail_table_tags1(inputs)
	if (locale === "sv") return sv_offerdetail_table_tags1(inputs)
	if (locale === "vi") return vi_offerdetail_table_tags1(inputs)
	if (locale === "tr") return tr_offerdetail_table_tags1(inputs)
	if (locale === "cs") return cs_offerdetail_table_tags1(inputs)
	if (locale === "bg") return bg_offerdetail_table_tags1(inputs)
	if (locale === "ru") return ru_offerdetail_table_tags1(inputs)
	if (locale === "uk") return uk_offerdetail_table_tags1(inputs)
	if (locale === "ar") return ar_offerdetail_table_tags1(inputs)
	if (locale === "hi") return hi_offerdetail_table_tags1(inputs)
	if (locale === "th") return th_offerdetail_table_tags1(inputs)
	if (locale === "ja") return ja_offerdetail_table_tags1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_tags1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_tags1(inputs)
	return ko_offerdetail_table_tags1(inputs)
});
export { offerdetail_table_tags1 as "offerDetail.table.tags" }